export default (to, from, next) => {
    next("/dev")
}